import { fetchWithAuth } from "./cartService";

const BASE_URL = process.env.REACT_APP_API_URL ; 

// =======================
// CREATE RAZORPAY ORDER
// POST /payments/create-order
// Returns: { orderId, amount, keyId }
// =======================
export const createRazorpayOrder = async (amount) => {
  try {
    const token = localStorage.getItem("accessToken");
    console.log("[createRazorpayOrder] token present:", !!token, "| starts with:", token?.slice(0, 20));
    const res = await fetchWithAuth(`${BASE_URL}/payments/create-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ amount }),
    });
    return await res.json();
  } catch (error) {
    console.error("Create Razorpay order error:", error);
    return null;
  }
};

// =======================
// VERIFY RAZORPAY PAYMENT
// POST /payments/verify
// =======================
export const verifyRazorpayPayment = async ({
  razorpay_order_id,
  razorpay_payment_id,
  razorpay_signature,
}) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/payments/verify`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        razorpay_order_id,
        razorpay_payment_id,
        razorpay_signature,
      }),
    });
    return await res.json();
  } catch (error) {
    console.error("Verify payment error:", error);
    return null;
  }
};

// =======================
// PLACE ORDER
// POST /orders
// NOTE: useReferralDiscount / useLoyaltyDiscount must be forwarded —
// these were previously silently dropped, so the backend never knew
// whether the loyalty 50%-off checkbox was checked.
// =======================
export const placeOrderAPI = async ({
  shippingAddress,
  paymentMethod,
  razorpayOrderId,
  razorpayPaymentId,
  useReferralDiscount,
  useLoyaltyDiscount,
}) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/orders`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        shippingAddress,
        paymentMethod,
        razorpayOrderId,
        razorpayPaymentId,
        useReferralDiscount,
        useLoyaltyDiscount,
      }),
    });
    return await res.json();
  } catch (error) {
    console.error("Place order error:", error);
    return null;
  }
};

// =======================
// GET MY ORDERS
// GET /orders/my-orders
// =======================
export const fetchMyOrders = async () => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/orders/my-orders`);
    return await res.json();
  } catch (error) {
    console.error("Fetch orders error:", error);
    return null;
  }
};

// =======================
// GET ORDER DETAIL
// GET /orders/:id
// =======================
export const fetchOrderById = async (orderId) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/orders/${orderId}`);
    return await res.json();
  } catch (error) {
    console.error("Fetch order error:", error);
    return null;
  }
};

// =======================
// CANCEL ORDER
// PUT /orders/:id/cancel
// =======================
export const cancelOrderAPI = async (orderId) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/orders/${orderId}/cancel`, {
      method: "PUT",
    });
    return await res.json();
  } catch (error) {
    console.error("Cancel order error:", error);
    return null;
  }
};